// extracted by mini-css-extract-plugin
export default {"container":"OmokfGgMHb1wXPgdT8aq"};